var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHamburgerMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 31,
  height: 30,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#333132",
  strokeLinecap: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M23 10H9M23 15H9M23 20H9"
}))));
export default SvgHamburgerMenu;